const projects = [


  {
    title: "ThinkTogether - AI-Powered Video Conferencing",
    image: "Pictures/chatbot.webp",
    tags: ["Current Project", "WebRTC", "AI/ML", "Microservices", "Real-time"],
    link: "VideoChat/",
    description: "Video conferencing application with AI assistant, with scalable microservices architecture, and multimodal AI processing for college students."
  },
  {
    title: "Conversational AI Pipeline",
    image: "Pictures/converse.png",
    tags: ["Current Project", "AI/ML", "Multimodal", "Python", "Real-time"],
    link: "ConversationalAI/",
    description: "Multimodal AI pipeline for real-time conversational AI that can see, hear, and understand context through audio, video, and screen content processing."
  },
  {
    title: "Modular Robots",
    image: "Pictures/AIML.png",
    tags: ["Robotics", "CAD", "Mechanical Design"],
    link: "Module/",
    description: "Modular robots designed for space and high-load applications."
  },
  {
    title: "Carpool Ride-Sharing Algorithm",
    image: "Pictures/Ride.png",
    tags: ["Algorithm", "MATLAB", "Optimization"],
    link: "RideShare/",
    description: "Algorithm for optimizing carpool ride-sharing routes and schedules."
  },

  {
    title: "Tesla Projects",
    image: "Pictures/tesla.jpeg",
    tags: ["Python", "Flask", "Data Analysis", "Machine Learning"],
    link: "Tesla/",
    description: "A collection of projects and automations built during my time at Tesla."
  },


  {
    title: "Gesture-Controlled Music Player",
    image: "Pictures/AppleWatch.jpg",
    tags: ["Swift", "Machine Learning", "iOS", "Gesture Recognition"],
    link: "AppleGuesture/",
    description: "Real-time gesture recognition system using Apple Watch motion sensors to control music playback through natural wrist movements."
  },

  {
    title: "Sound Recognition",
    image: "Pictures/sound_rec.jpg",
    tags: ["Machine Learning", "Python", "Audio Processing"],
    link: "SoundRec/",
    description: "Recognizing and classifying audio using machine learning techniques."
  },
  {
    title: "AI Hosting Application",
    image: "Pictures/gemini.png",
    tags: ["Next.js", "TypeScript", "AI", "Web App"],
    link: "AIContent/",
    description: "A full-stack platform for generating, managing, and hosting AI-generated content with authentication, dashboard, templates, and billing."
  },

  {
    title: "BMW Projects",
    image: "Pictures/BMW.jpeg",
    tags: ["Python", "JavaScript", "Automation"],
    link: "BMW/",
    description: "Software and automation projects developed at BMW."
  },

  {
    title: "Personal Portfolio",
    image: "Pictures/PersonalPortfolio.png",
    tags: ["HTML", "CSS", "JavaScript", "Web Design", "Go"],
    link: "PP/",
    description: "My personal portfolio website showcasing the evolution from V1 to V2 with modern design improvements."
  },
  {
    title: "Remote Control and Autonomous Quadrotor",
    image: "Pictures/quad.png",
    tags: ["C++", "Embedded Systems", "PID Control", "Robotics"],
    link: "Quadrotor/",
    description: "3D-printed quadrotor with PID control system, VIVE sensors, and semi-autonomous flight capabilities."
  },

  {
    title: "Financial Anomaly Detection",
    image: "Pictures/stocks.jpeg",
    tags: ["AWS", "Machine Learning", "PyTorch", "Anomaly Detection"],
    link: "AnomolyDetection/",
    description: "Comprehensive AWS-powered financial anomaly detection system with LSTM neural networks, real-time alerts, and LLM integration for stock market analysis."
  },


  {
    title: "PID Motor Control",
    image: "Pictures/PID.png",
    tags: ["C", "Embedded Systems", "PID Control", "Motor Control"],
    link: "Motor/",
    description: "Closed-loop motor control system using PIC32 microcontroller with real-time current and position control loops and trajectory tracking."
  },
  {
    title: "Active Learning & Optimal Control Portfolio",
    image: "Pictures/active-learning.jpg",
    tags: ["Python", "Active Learning", "Optimal Control", "Robotics"],
    link: "ActiveLearning/",
    description: "Portfolio showcasing five interconnected projects exploring probabilistic modeling, active sensing, Bayesian filtering, and optimal control with robotics applications."
  },
  {
    title: "Checkers Ai Bot",
    image: "Pictures/checkers.jpg",
    tags: ["Python", "AI", "Game Design"],
    link: "Checkers/",
    description: "An AI bot for playing Checkers, built in Python."
  },
  {
    title: "Machine Learning Projects",
    image: "Pictures/ML_proj.png",
    tags: ["Machine Learning", "PyTorch", "Python"],
    link: "ML/",
    description: "A collection of machine learning projects."
  },
  
  {
    title: "Fall Sensing",
    image: "Pictures/falling.png",
    tags: ["R", "Data Analysis", "Machine Learning", "Sensors"],
    link: "FallSensing/",
    description: "Wearable sensor-based fall detection system for manufacturing workers using biometric data and regression models."
  },
  {
    title: "Tetris",
    image: "Pictures/tetris.jpeg",
    tags: ["C++", "Game Design"],
    link: "Tetris/",
    description: "A C++ implementation of the classic Tetris game."
  },
  {
    title: "Electrical Design Projects",
    image: "Pictures/electricaldesign.png",
    tags: ["Electrical Design", "C", "Embedded Systems"],
    link: "ED/",
    description: "Collection of electrical design projects including games, sensors, amplifiers, and control systems using PIC32 and Pico microcontrollers."
  },

  {
    title: "Gearbox Design",
    image: "Pictures/gearbox.png",
    tags: ["CAD", "Mechanical Design", "Stress Analysis"],
    link: "geardesign/",
    description: "Design and analysis of a mechanical gearbox."
  },

  {
    title: "Jack-In Box Simulation",
    image: "Pictures/jackinbox.png",
    tags: ["Python", "Simulation"],
    link: "Jack/",
    description: "A simulation of a Jack-in-the-Box using Python."
  },
  {
    title: "Review Sentiment Checker",
    image: "Pictures/review.jpeg",
    tags: ["Machine Learning", "Python", "NLP"],
    link: "ReviewAnalysis/",
    description: "A tool for checking sentiment in reviews using ML."
  },
  
  {
    title: "Parallel Kinematics Manipulator",
    image: "Pictures/PKM.png",
    tags: ["CAD", "Mechanical Design", "Robotics"],
    link: "PKM/",
    description: "Design and analysis of a parallel kinematics manipulator."
  },

  {
    title: "Infection Disease Population Modeling",
    image: "Pictures/sync.png",
    tags: ["MATLAB", "Simulation", "Modeling"],
    link: "Sync/",
    description: "SIR and SIS models for infectious disease population modeling with analytical solutions and numerical comparisons."
  },

  {
    title: "Trip Planning API",
    image: "Pictures/FLIGHT.png",
    tags: ["Racket", "Graph Algorithms", "API"],
    link: "Trip/",
    description: "Intelligent routing and search API with advanced graph algorithms for shortest path calculations and POI discovery."
  },


 

];

// Export for ES6 modules
export default projects;

// Also make available globally for browser compatibility
window.projects = projects;